export const RENEWALS_DETAILS = "RENEWALS_DETAILS";
export const RENEWALS_DETAILS_FETCH_FAILED = "RENEWALS_DETAILS_FETCH_FAILED";
export const UPDATE_RENEWALS_TAB_INDEX = "UPDATE_RENEWALS_TAB_INDEX";
